import type { PerksProps } from './perks.component';

/**
 * Maps HTML attribute names (kebab-case) to PerksComponent prop names (camelCase)
 */
export const PERKS_ATTRIBUTE_MAP: Record<string, keyof PerksProps> = {
  'membership-id': 'membershipId',
  display: 'display',
  'logged-in': 'loggedIn',
  'internal-title': 'internalTitle',
  'title-size': 'titleSize',
  description: 'description',
  columns: 'columns',
  'column-alignment': 'columnAlignment',
  'show-search': 'showSearch',
  'show-banner-image': 'showBannerImage',
  'show-program-name': 'showProgramName',
  'show-tier-image': 'showTierImage',
  'show-tier-name': 'showTierName',
  'show-tier-description': 'showTierDescription',
  'show-quick-add': 'showQuickAdd',
  'show-recent-posts': 'showRecentPosts',
  'show-video-title': 'showVideoTitle',
  'show-video-date': 'showVideoDate',
  'max-width': 'maxWidth',
  'card-background-color': 'cardBackgroundColor',
  'card-text-color': 'cardTextColor',
  'card-button-color': 'cardButtonColor',
  'card-button-text-color': 'cardButtonTextColor',
  'column-border-color': 'columnBorderColor',
  'column-border-width': 'columnBorderWidth',
  'border-radius': 'borderRadius',
  'horizontal-padding': 'horizontalPadding',
  'vertical-padding': 'verticalPadding',
  'page-width': 'pageWidth',
};

/**
 * Properties that should be converted from string to boolean
 */
const BOOLEAN_PROPS = new Set([
  'showSearch',
  'showBannerImage',
  'showProgramName',
  'showTierImage',
  'showTierName',
  'showTierDescription',
  'showQuickAdd',
  'showRecentPosts',
  'showVideoTitle',
  'showVideoDate',
  'maxWidth',
]);

/**
 * Converts a string attribute value to the appropriate type
 */
function convertAttributeValue(propName: string, value: string): any {
  if (BOOLEAN_PROPS.has(propName)) {
    // Convert string "true"/"false" to boolean
    return value === 'true';
  }
  return value;
}

/**
 * Extracts attributes from an HTMLElement and converts them to PerksProps
 */
export function extractPerksAttributes(element: HTMLElement): Partial<PerksProps> {
  const props: Partial<PerksProps> = {};

  for (const [attrName, propName] of Object.entries(PERKS_ATTRIBUTE_MAP)) {
    const value = element.getAttribute(attrName);
    if (value !== null) {
      (props as any)[propName] = convertAttributeValue(propName, value);
    }
  }

  return props;
}
